/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import {
  NotifyWalletConnectRequest,
  NotifyWalletConnectRequestFromJSON,
  NotifyWalletConnectRequestToJSON,
} from '../models'

export interface NotifyWalletConnectOperationRequest {
  notifyWalletConnectRequest?: NotifyWalletConnectRequest
}

/**
 *
 */
export class AnalyticsApi extends runtime.BaseAPI {
  /**
   */
  async notifyWalletConnectRaw(
    requestParameters: NotifyWalletConnectOperationRequest,
    initOverrides?: RequestInit,
  ): Promise<runtime.ApiResponse<void>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/api/analytics/notify/wallet-connect`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: NotifyWalletConnectRequestToJSON(requestParameters.notifyWalletConnectRequest),
      },
      initOverrides,
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   */
  async notifyWalletConnect(
    requestParameters: NotifyWalletConnectOperationRequest = {},
    initOverrides?: RequestInit,
  ): Promise<void> {
    await this.notifyWalletConnectRaw(requestParameters, initOverrides)
  }
}
